import languageList from "./list";
export function useLanguage(language) {
    return languageList[language !== null && language !== void 0 ? language : "nl"];
}
;
